import { styled } from '@mui/material/styles';
import MUITab from '@mui/material/Tab';
import React from 'react';

const NewTab = (props) => {
    const StyledTab = styled((props) => <MUITab disableRipple {...props} />)(({ theme }) => ({
        '&': {
            fontSize: '14px',
            textTransform: 'none',
        },
        '&.MuiButtonBase-root.MuiTab-root:not(.Mui-selected)': {
            color: 'rgba(0, 0, 0, 0.6)',
        },
        '&.Mui-selected': {
            background: '#F8F8F8',
        },
        '&.MuiButtonBase-root': {
            maxWidth: '33%',
        },
        ...(props.minWidth && {
            '&.MuiButtonBase-root': {
                width: '25%',
                fontSize: '12px',
            },
        }),
    }));

    return <StyledTab {...props}>{props.children}</StyledTab>;
};

export default NewTab;
